import React from 'react';

var SvgCalendarBookedLg = function SvgCalendarBookedLg(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M28.075 10.481h-24.15c-.242 0-.437.196-.437.438v16.275c0 .241.195.437.437.437h24.15c.242 0 .438-.196.438-.437v-16.275c0-.242-.196-.438-.438-.438m-24.15-1.487c-1.063 0-1.925.862-1.925 1.925v16.275c0 1.063.862 1.925 1.925 1.925h24.15c1.063 0 1.925-.862 1.925-1.925v-16.275c0-1.063-.862-1.925-1.925-1.925z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.195 15.095c.274-.307.744-.333 1.05-.06l2.073 1.851c.307.274.333.744.06 1.05-.274.307-.744.333-1.05.06l-2.073-1.851c-.307-.274-.333-.744-.06-1.05",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.457 13.78c.256.322.203.79-.119 1.046l-4.014 3.197c-.321.256-.79.203-1.045-.119-.256-.321-.203-.789.118-1.045l4.015-3.197c.32-.256.789-.203 1.045.118",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.125 3c.41 0 .744.333.744.744v2.625c0 .41-.333.744-.744.744-.41 0-.744-.333-.744-.744v-2.625c0-.411.333-.744.744-.744",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.875 3c.41 0 .744.333.744.744v2.625c0 .41-.333.744-.744.744-.41 0-.744-.333-.744-.744v-2.625c0-.411.333-.744.744-.744",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.188 17.131c.87 0 1.574-.705 1.574-1.575s-.705-1.575-1.575-1.575-1.574.705-1.574 1.575.705 1.575 1.575 1.575m0 1.488c1.69 0 3.062-1.371 3.062-3.063 0-1.691-1.371-3.062-3.062-3.062-1.692 0-3.063 1.37-3.063 3.062s1.371 3.063 3.063 3.063",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.188 24.131c.87 0 1.574-.705 1.574-1.575s-.705-1.575-1.575-1.575-1.574.705-1.574 1.575.705 1.575 1.575 1.575m0 1.488c1.69 0 3.062-1.371 3.062-3.063 0-1.691-1.371-3.062-3.062-3.062-1.692 0-3.063 1.37-3.063 3.062s1.371 3.063 3.063 3.063",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.813 24.131c.87 0 1.575-.705 1.575-1.575s-.706-1.575-1.576-1.575-1.575.705-1.575 1.575.706 1.575 1.576 1.575m0 1.488c1.69 0 3.062-1.371 3.062-3.063 0-1.691-1.371-3.062-3.062-3.062-1.692 0-3.063 1.37-3.063 3.062s1.371 3.063 3.063 3.063",
    clipRule: "evenodd"
  }));
};
SvgCalendarBookedLg.displayName = "CalendarBookedLg";

export { SvgCalendarBookedLg as S };
